const initialState = {
    pending: false,
    users: [],
    error: null,
    selected: {}
};

const usersReducer = (state = initialState, action) => {
    switch (action.type) {
        case 'GET_USERS_PENDING':
            return {
                ...state,
                pending: true
            };
        case 'GET_USERS_SUCCESS':
            return {
                ...state,
                pending: false,
                users: action.users,
                pagination: {
                    page: action.page,
                    numberOnPage: action.numberOnPage,
                    pageCount: action.pageCount,
                    itemsCount: action.usersCount
                }
            };
        case 'USERS_ERROR':
            return {
                ...state,
                pending: false,
                error: action.error
            };
        case 'SELECT_USER':
            return {
                ...state,
                selected: action.selected
            };
        case 'ADD_USER_SUCCESS':
            return {
                ...state,
                pending: false
            };
        default:
            return state;
    }
};

export default usersReducer;
